import * as React from "react";
import SingleCard from "./SingleCard";
import DoubleCard from "./DoubleCard";
import TripleCard from "./TripleCard";
import RollableCard from "./RollableCard";
import { getTomatoWidth } from "./utils";
export default function TomatoCard(props) {
    const { isRollable, posterRadio, placeholderBg, poolId, onClick } = props;
    let { columnNum } = props;
    const commonProps = Object.assign(Object.assign({ product: props === null || props === void 0 ? void 0 : props.productElement, placeholderBg }, getTomatoWidth(columnNum, posterRadio, isRollable)), { poolId });
    if (![1, 2, 3].includes(columnNum)) {
        columnNum = 2;
    }
    let ProductSkeleton;
    switch (columnNum) {
        case 1:
            ProductSkeleton = SingleCard;
            break;
        case 2:
            if (isRollable) {
                ProductSkeleton = RollableCard;
            }
            else {
                ProductSkeleton = DoubleCard;
            }
            break;
        case 3:
            ProductSkeleton = TripleCard;
            break;
        default:
            ProductSkeleton = DoubleCard;
    }
    return React.createElement(ProductSkeleton, Object.assign({ onClick: onClick }, commonProps));
}
